import { call, put, takeEvery } from 'redux-saga/effects';
import { DeleteSalesAdminObject, SalesAdminActionKeys } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { lookupActionCreators } from '../../lookups';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { deleteObj } from '../salesAdminApi';

function* deleteSalesAdminObjectSaga(action: DeleteSalesAdminObject) {
  yield put(uiActionCreators.showSpinnerDialog());

  const response: IApiExecuteRespone = yield call(deleteObj, action.payload.endpoint, action.payload.id);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else {
    yield put(lookupActionCreators.removeLookupValue({ type: action.payload.type, id: action.payload.id }));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteSalesAdminObject() {
  yield takeEvery(SalesAdminActionKeys.DELETE_SALES_ADMIN_OBJECT, deleteSalesAdminObjectSaga);
}
